



import { Component, Vue } from 'vue-property-decorator';
import AuthCard from "@/components/Organisms/AuthCard/AuthCard.vue";
import SuccessIcon from "@/components/Atoms/SuccessIcon/SuccessIcon.vue";
import RegisterForm from "@/components/Molecules/RegisterForm/RegisterForm.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";

@Component({
  components: {
    AuthCard,
    RegisterForm,
    ButtonSuccessful,
    SuccessIcon
  }
})
export default class ResetPasswordSuccess extends Vue {
  private currentEmail = ''
  private created() {
    // TODO
  }

  get email(): string {
    if (this.currentEmail) return this.currentEmail
    return 'abc@gmail.com'
  }

  private async onClickButtonBackToLogin() {
    // TODO
    this.$router.push({ name: 'routes.auth.login' })
  }
}
